import React, { useState } from 'react';
import axios from 'axios';
import API_URL from './config';

function Login({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    role: 'KAM'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        const response = await axios.post(`${API_URL}/api/auth/login`, {
          email: formData.email,
          password: formData.password
        });

        if (response.data.success) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          onLogin(response.data.user);
        }
      } else {
        const response = await axios.post(`${API_URL}/api/auth/register`, formData);
        
        if (response.data.success) {
          alert('Registration successful! Please login.');
          setIsLogin(true);
          setFormData({ email: '', password: '', name: '', role: 'KAM' });
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img 
              src="/logo.png" 
              alt="RV Solutions" 
              style={{
                height: '64px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
          <h1>Welcome Back</h1>
          <p>{isLogin ? 'Sign in to your account' : 'Create your account'}</p>
        </div>

        {error && (
          <div className="message-toast error" style={{ position: 'static', marginBottom: '20px' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {!isLogin && (
            <>
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="premium-input"
                  placeholder="John Doe"
                  required
                />
              </div>

              <div className="form-group">
                <label>Role</label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="premium-select"
                >
                  <option value="KAM">KAM</option>
                  <option value="Admin">Admin</option>
                  <option value="Viewer">Viewer</option>
                </select>
              </div>
            </>
          )}

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="premium-input"
              placeholder="you@rvsolutions.in"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="premium-input"
              placeholder="••••••••"
              required
            />
          </div>

          <button 
            type="submit" 
            className="premium-button"
            style={{ width: '100%', marginTop: '24px' }}
            disabled={loading}
          >
            {loading ? (
              <span className="loading-spinner" style={{ width: 20, height: 20 }} />
            ) : (
              isLogin ? 'Sign In' : 'Create Account'
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <button 
              onClick={() => setIsLogin(!isLogin)}
              className="text-button"
            >
              {isLogin ? 'Sign up' : 'Sign in'}
            </button>
          </p>
        </div>
      </div>

      <style jsx>{`
        .login-container {
          min-height: calc(100vh - 100px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }

        .login-card {
          background: var(--glass-background);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid var(--glass-border);
          border-radius: 32px;
          padding: 40px;
          width: 100%;
          max-width: 440px;
          box-shadow: var(--system-shadow-lg);
          animation: slideIn 0.5s ease;
        }

        .login-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .login-logo {
          margin-bottom: 24px;
          display: flex;
          justify-content: center;
        }

        .login-header h1 {
          font-size: 28px;
          margin-bottom: 8px;
        }

        .login-header p {
          color: var(--system-secondary-label);
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: var(--system-secondary-label);
        }

        .login-footer {
          text-align: center;
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px solid var(--system-separator);
        }

        .text-button {
          background: none;
          border: none;
          color: var(--system-blue);
          font-weight: 500;
          cursor: pointer;
          padding: 4px 8px;
        }

        .text-button:hover {
          text-decoration: underline;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default Login;